import { useCallback, useState } from 'react';

export const useInputs = <T extends {}>(
  initialForm: T,
): [
  T,
  (e: {
    target: {
      name: string;
      value: any;
    };
  }) => void,
  (name: string, value: any) => void,
  () => void,
] => {
  const [state, setState] = useState(initialForm);
  const onChange = useCallback(
    (e: {
      target: {
        name: string;
        value: any;
      };
    }) => {
      setState((prev) => ({
        ...prev,
        [e.target.name]: e.target.value,
      }));
    },
    [],
  );

  const onCustomChange = useCallback((name: string, value: any) => {
    setState((prev) => {
      const result = {
        ...prev,
        [name]: value,
      };
      return result;
    });
  }, []);

  const initialize = () => {
    setState(initialForm);
  };

  return [state, onChange, onCustomChange, initialize];
};
